import React from 'react';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';
import { Separator } from '../../CommonComponents/OPL/Separator/Separator';
import { YourInfoGrid } from './components/YourInfo/YourInfo.styles';
import { PartnerInfoGrid } from './components/PartnerInfo/PartnerInfo.styles';
import { DependentsGrid } from './components/Dependents/Dependents.styles';

const LoadingFormField = () => {
  return (
    <div>
      <Shimmer width={100} height={16} mb="8" />
      <Shimmer width="100%" height={36} />
    </div>
  );
};

export const PersonalInfoLoading = () => {
  return (
    <>
      <Shimmer width={190} height={24} mb="32" />

      <YourInfoGrid>
        <LoadingFormField />
        <LoadingFormField />
        <LoadingFormField />
        <LoadingFormField />
        <div />
        <LoadingFormField />
        <LoadingFormField />
      </YourInfoGrid>

      <Shimmer width={130} height={32} mt="32" />

      <Separator my="32" />

      <Shimmer width={190} height={24} mb="32" />

      <PartnerInfoGrid>
        <LoadingFormField />
        <LoadingFormField />
        <div />
        <LoadingFormField />
      </PartnerInfoGrid>

      <Separator my="32" />

      <Shimmer width={190} height={24} mb="32" />

      <PartnerInfoGrid>
        <LoadingFormField />
        <LoadingFormField />
      </PartnerInfoGrid>

      <Shimmer width={190} height={24} mt="32" />

      <Separator my="32" />

      <DependentsGrid>
        <LoadingFormField />
        <LoadingFormField />
        <LoadingFormField />
        <LoadingFormField />
      </DependentsGrid>

      <Shimmer width={190} height={24} mt="32" />
    </>
  );
};
